/**
 * @Author: 左建
 * @Date: 2022/8/30 15:11
 * @LastEditTime: 2022/8/30 15:11
 * @Description: 课程相关接口
*/
import {
    post,
    get,
    postFormData,
    requestData
} from "@/utils/request";

import { clearObjEmptyStr } from "@/utils"
// 获取课程列表
export function getCourseList (params) {
    const { total, ...otherProps } = params
    return post("/Manage/CustomSource/GetListForWeb", otherProps, true, otherProps)
}
